import { watch } from 'vue'
import { useDocumentVisibility, useTimeoutPoll } from '@vueuse/core'

import { useWebSiteStore } from '@/stores/web-site.store'

export const usePolling = (callbackAsync) => {
  const webSiteStore = useWebSiteStore()
  const poll = useTimeoutPoll(callbackAsync, webSiteStore.getNotificationsInterval(), { immediate: true })
  watch(useDocumentVisibility(), (visibility) => (visibility === 'visible' ? poll.resume() : poll.pause()))
}
